import { tr } from "../../i18n";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "../../auth/AuthContext";
import { Badge, EmptyState, fmtDateTime } from "../../components/portal";
export default function AdminClients() {
  const {
    lang = "en"
  } = useParams();
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  const load = (s = search) => {
    api.get(`/admin/clients?search=${encodeURIComponent(s)}&limit=100`).then(r => setData(r.data)).catch(() => {});
  };
  useEffect(() => {
    load("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div className="mx-auto max-w-6xl" data-testid="admin-clients-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-esaia-ink">{tr("Clients")}</h1>
          <p className="mt-1 text-sm text-esaia-muted">{tr("Every registered client organization.")}</p>
        </div>
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-esaia-subtle" />
          <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === "Enter" && load()} placeholder={tr("Search name, company, email")} data-testid="clients-search-input" className="w-64 border border-esaia-line bg-white py-2.5 pl-9 pr-3 text-sm text-esaia-ink placeholder:text-esaia-subtle focus:border-esaia-blue focus:outline-none" />
        </div>
      </div>

      <div className="mt-6">
        {!data ? <p className="text-sm text-esaia-subtle">{tr("Loading...")}</p> : data.items.length === 0 ? <EmptyState message={tr("No clients registered yet.")} /> : <div className="overflow-x-auto border border-esaia-line bg-white">
            <table className="w-full min-w-[820px]" data-testid="clients-table">
              <thead>
                <tr className="border-b border-esaia-line bg-esaia-surface text-left">
                  {["Name", "Company", "Email", "Active", "Completed", "Latest activity", "Status"].map(h => <th key={h} className="px-5 py-3 font-mono text-[10px] uppercase tracking-[0.18em] text-esaia-subtle">{tr(h)}</th>)}
                </tr>
              </thead>
              <tbody>
                {data.items.map(c => <tr key={c.id} className="border-b border-esaia-line transition-colors last:border-0 hover:bg-esaia-canvas">
                    <td className="px-5 py-3.5 text-sm">
                      <Link to={`/${lang}/admin/clients/${c.id}`} className="font-semibold text-esaia-ink hover:text-esaia-blue" data-testid={`client-row-${c.id}`}>
                        {c.first_name} {c.last_name}
                      </Link>
                    </td>
                    <td className="px-5 py-3.5 text-sm text-esaia-muted">{c.company || "—"}</td>
                    <td className="px-5 py-3.5 text-sm text-esaia-muted">{c.email}</td>
                    <td className="px-5 py-3.5 font-mono text-sm text-esaia-ink">{c.active_assessments}</td>
                    <td className="px-5 py-3.5 font-mono text-sm text-esaia-ink">{c.completed_assessments}</td>
                    <td className="px-5 py-3.5 font-mono text-[11px] text-esaia-subtle">{fmtDateTime(c.latest_activity)}</td>
                    <td className="px-5 py-3.5"><Badge tone={c.status === "active" ? "green" : "slate"}>{tr(c.status || "active")}</Badge></td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>
    </div>;
}
